export const NOTIFICATIONS_PANEL_PAGE_SIZE = 7;
export const REFRESH_UNREAD_COUNT_INTERVAL = 300000;
export const i18Cmp = "notifications";
export const i18CmpButtons = `${i18Cmp}.buttons`;
export const i18CmpNotificationsUnread = `${i18Cmp}.notifications_unread`;
export const i18CmpNotificationsCategories = `${i18Cmp}.categories.`;
export const i18CmpFilter = i18Cmp + ".filter";
export const i18CmpFilterOptions = i18Cmp + ".filter.options";
export const ALL_CATEGORIES = "all";

export enum FILTER_OPTIONS {
  ALL = "all",
  UNREAD = "unread",
}
